<template lang="html">
  <transition name="result" mode="out-in">
    <div class="homeResult">
      <div ref="grid" class="grid homeResult-cover">
        <div :style="{width: 100 / columns + '%'}" class="grid-sizer"></div>
        <div :style="{width: 100 / columns * getColumnsCount() + '%'}"  v-for="image in images" class="grid-item animateIn">
          <img
          @load="loaded"
          :style="`transform: scale(${1 - Math.random() / 7})`"
          :src="image.url">
        </div>

      </div>
      <div class="homeResult-title animateIn">{{result[0]}}</div>
      <div class="homeResult-desc animateIn">{{result[1]}} — <a href="tel:+79219284555">звоните</a>. Подробнее о том, как мы работаем читайте в разделе <router-link to="/about">Наш подход</router-link>.</div>
    </div>
  </transition>
</template>

<script>
import HomeResultImage from '@/components/HomeResultImage'
import Masonry from 'masonry-layout'
import _ from 'underscore'

let count = 0

export default {
  name: 'HomeResult',
  components: {
    HomeResultImage
  },
  props: ['images'],
  mounted () {
    this.masonry = new Masonry('.grid', {
      // itemSelector: '.homeResult-image',
      columnWidth: '.grid-sizer',
      percentPosition: true,
      transitionDuration: 0
    });
    if (this.images.length == 0) {
      this.animateIn()
    }
  },
  methods: {
    loaded () {
      this.masonry.layout()
      count++
      if (count > this.images.length - 1) {
        this.animateIn()
      }
    },
    getRandomFloat (min, max) {
      return Math.random() * (max - min) + min;
    },
    getColumnsCount () {
      // return (Math.random() < 0.1) ? 2 : 1
      return 1
      return _.sample([1, 2])
    },
    animateIn () {
      TweenMax.staggerTo('.animateIn', .6, {
        scale: 1,
        opacity: 1,
        ease: Power3.easeInOut,
      }, 0.05, () => {

      })

    }
  },
  computed: {
    columns () {
      return (this.images.length < 4) ? this.images.length : 3
    },
    result () {
      return [
        ['Ничего не понравилось?','В шоуруме точно что-нибудь подберем '],
        ['Вам мало что нравится','Но с нами вам понравится '],
        ['Хорошая подборка!','Все это (и многое другое!) вы можете заказать в нашем шоуруме '],
        ['Интересная подборка','Все это (и многое другое!) вы можете заказать в нашем шоуруме '],
        ['Отличный вкус','Все это (и многое другое!) вы можете заказать в нашем шоуруме '],
        ['Прекрасный выбор','Все это (и многое другое!) вы можете заказать в нашем шоуруме '],
        ['Прекрасный выбор','Все это (и многое другое!) вы можете заказать в нашем шоуруме '],
        ['Вы разбираетесь в мебели!','Все это (и многое другое!) вы можете заказать в нашем шоуруме '],
        ['Вы любите мебель!','Все это (и многое другое!) вы можете заказать в нашем шоуруме '],
        ['Вы любите мебель!','Все это (и многое другое!) вы можете заказать в нашем шоуруме '],
        ['Вы любите мебель!','Все это (и многое другое!) вы можете заказать в нашем шоуруме '],
        ['Вам все понравилось!','Тогда мы созданы друг для друга... '],
      ][this.images.length]
    },
  }
}
</script>

<style lang="scss" scoped>
@import '../scss/settings';
@import '../scss/mixins';

.homeResult {
  margin-top: 95px;
  position: relative;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.homeResult-title {
  padding: $padding $padding 0;
  font-size: 28px;
  line-height: 1em;
  opacity: 0;
}

.homeResult-desc {
  padding: $padding;
  opacity: 0;
  a {
    border-bottom: 1px solid #d8d8d8;
    // background-color: #d8d8d8;
  }
}

.homeResult-cover {
  // padding-bottom: 66%;
  position: relative;
}

.homeResult-image {
  // position: absolute;
}

.grid-sizer,
.grid-item {
  // width: 33.3333%;
}

.grid-item {
  padding: 5px;
  opacity: 0;
  transform: scale(0.95);
  img {
    width: 100%;
    display: block;
  }
}



</style>



// WEBPACK FOOTER //
// src/components/HomeResult.vue